<template lang="pug">
  .lesson-block-franch-team-rate__stars-list(
    @mouseleave="clearStars"
  )
    svg.lesson-block-franch-team-rate__star(
      v-for="(star, idx) in stars" :key="idx"
      :class="{'-answered-': answered}"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 13 12" fill="none"
      @mouseenter="showStarsPreview(idx)"
      @click="setStarsAmount(idx)"
    )
      path(
        v-if="star.type === 'full'"
        d="M6.25033 9.07449L9.85533 11.2503L8.89866 7.14949L12.0837 4.39033L7.88949 4.03449L6.25033 0.166992L4.61116 4.03449L0.416992 4.39033L3.60199 7.14949L2.64533 11.2503L6.25033 9.07449Z" fill="#FECB52"
      )
      path(
        v-else-if="star.type === 'empty'"
        d="M5.83333 8.9075L9.43833 11.0833L8.48167 6.9825L11.6667 4.22333L7.4725 3.8675L5.83333 0L4.19417 3.8675L0 4.22333L3.185 6.9825L2.22833 11.0833L5.83333 8.9075Z" fill="#DFE0EB"
      )

</template>

<script>
export default {
  props: ['propStars', 'answered'],
  data: () => ({
    selectedStars: 0,
    previewStars: -1
  }),
  computed: {
    stars() {
      const stars = [];
      if (this.previewStars >= 0) {
        for (let i = 0; i < this.previewStars; i++) {
          stars.push({
            type: 'full'
          });
        }
      } else {
        for (let i = 0; i < this.selectedStars; i++) {
          stars.push({
            type: 'full'
          });
        }
      }

      while (stars.length < 10) {
        stars.push({
          type: 'empty'
        });
      }
      return stars;
    }
  },
  watch: {
    propStars(val) {
      if (val !== this.selectedStars) {
        this.setStars();
      }
    }
  },
  mounted() {
    this.setStars();
  },
  methods: {
    setStars() {
      if (typeof this.propStars === 'number') {
        this.selectedStars = this.propStars;
      }
    },
    showStarsPreview(idx) {
      if (!this.answered) {
        this.previewStars = idx + 1;
      }
    },
    setStarsAmount(idx) {
      if (!this.answered) {
        this.selectedStars = idx + 1;
        this.previewStars = -1;
        this.$emit('update:propStars', idx + 1);
      }
    },
    clearStars() {
      if (!this.answered) {
        this.previewStars = -1;
      }
    }
  }
};
</script>
